/* tslint:disable */

/**
 */
export class Coordinates {
    x?: number;
    y?: number;
    z?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/coordinates.ts